import styles from './ReportBlockPreview.module.scss'

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.style]
 */
export const ReportBlockPreview = ({ children, className, style }) => (
  <div className={cn(styles['report-block'], className)} style={style}>
    {children}
  </div>
)

/** @param  {...(string | undefined)} classes */
const cn = (...classes) => classes.filter(Boolean).join(' ')
